export const LANGUAGES = [
  { code: "ro", label: "Română", short: "RO" },
  { code: "en", label: "English", short: "EN" },
  { code: "bg", label: "Български", short: "BG" },
  { code: "sr", label: "Srpski", short: "SR" },
  { code: "hu", label: "Magyar", short: "HU" },
];

export const translations = {
  ro: {
    docTitle: "UBA COMPANY — Sediul social real al firmei tale în București",
    nav: {
      services: "Servicii",
      whyUs: "De ce noi",
      pricing: "Prețuri",
      process: "Proces",
      faq: "Întrebări",
      gdpr: "GDPR",
      contact: "Contact",
      cta: "Solicită oferta",
      menu: "Meniu",
    },
    hero: {
      badge: "București · România",
      title: "Sediul social real al firmei tale,",
      titleAccent: "în inima Bucureștiului",
      subtitle:
        "Domiciliu legal cu birou fizic real în București — nu virtual. Preț fix, totul inclus, fără surprize. Răspundem în cel mult 24 de ore, în limba ta.",
      ctaPrimary: "Solicită oferta",
      ctaSecondary: "Vezi serviciile",
      chips: [
        "Birou real, nu virtual",
        "Preț fix, totul inclus",
        "Răspuns în 24h",
      ],
      heroPrice: "de la 250 RON/an · ≈ 50 EUR",
      promo: {
        offer: "OFERTĂ",
        until: "până la 01.01.2027",
        free: "COD EORI GRATUIT",
        withAny: "cu orice serviciu",
      },
      imageAlt: "Clădire de birouri modernă",
    },
    video: {
      title: "Cum funcționează UBA COMPANY",
    },
    services: {
      label: "Servicii",
      title: "Tot ce are nevoie firma ta pentru un sediu social real",
      subtitle:
        "De la adresa juridică la spațiul fizic de lucru — fără soluții virtuale.",
      highlight: {
        title: "Demersuri legale și contracte",
        desc: "Realizăm orice demers legal de care are nevoie firma ta — contracte, acte și documente oficiale — cu preț fix, stabilit de la început.",
        cta: "Solicită oferta",
        list: [
          "Dizolvări și radieri de firme",
          "Cesiuni de părți sociale și firme complete",
          "Modificări și actualizări ale datelor firmei",
          "Schimbări și adăugări de coduri CAEN",
        ],
      },
      items: [
        {
          title: "Domiciliu legal (sediul social)",
          desc: "Adresă juridică reală pentru înregistrarea firmei la ONRC, valabilă pentru toate instituțiile.",
        },
        {
          title: "Birouri reale în București",
          desc: "Spații fizice de birou pe care le poți folosi cu rezervare. Prețuri în funcție de timpul necesar — plătești doar cât ai nevoie.",
        },
        {
          title: "Recepție și corespondență",
          desc: "Primim, scanăm și îți transmitem corespondența oficială la adresa reală.",
        },
        {
          title: "Suport înregistrare ONRC",
          desc: "Te ghidăm cu documentele pentru sediul social în dosarul de înregistrare.",
        },
      ],
    },
    whyUs: {
      label: "De ce UBA COMPANY",
      title: "Trei motive simple",
      items: [
        {
          title: "Preț fix, totul inclus",
          desc: "Știi exact cât plătești de la început. Fără costuri ascunse, fără surprize.",
        },
        {
          title: "Răspuns în 24 de ore, în limba ta",
          desc: "Răspundem în română, engleză, bulgară, sârbă sau maghiară — în cel mult 24 de ore.",
        },
        {
          title: "Birou real, nu virtual",
          desc: "Sediul social este un birou fizic real în București, pe care îl poți vizita oricând.",
        },
      ],
    },
    pricing: {
      label: "Prețuri",
      title: "Preț fix, totul inclus",
      subtitle:
        "Alege pachetul potrivit și primești oferta exactă în cel mult 24 de ore.",
      priceLabel: "Preț fix la cerere",
      priceNote: "Preț valabil pentru contracte cu durată minimă de 24 de luni. Prețul pentru 12 luni: 300 RON, toate taxele incluse.",
      cta: "Solicită oferta",
      note: "Fiecare ofertă este cu preț fix, totul inclus — fără costuri ascunse.",
      note2: "Notă: în prețurile noastre nu sunt incluse taxele percepute de ONRC.",
      plans: [
        {
          name: "Găzduire firmă",
          desc: "Sediul social pentru firma ta",
          price: { prefix: "de la", amount: "250 RON", suffix: "/an", eur: "≈ 50 EUR/an" },
          features: [
            "Adresă juridică reală",
            "Recepție corespondență",
            "Contract de închiriere a sediului agreat de ONRC",
          ],
        },
        {
          name: "Găzduire firmă + redactare acte",
          desc: "Redactarea actelor inclusă",
          price: { prefix: "de la", amount: "700 RON", suffix: "/an", eur: "≈ 140 EUR/an" },
          features: [
            "Birou fizic în București",
            "Acces la toată documentația oficială a companiei",
            "Redactarea tuturor actelor pentru SRL, PFA, II etc.",
          ],
          popular: "Cel mai ales",
        },
        {
          name: "Alte servicii pe care le oferim",
          desc: "Demersuri legale la cerere",
          price: { prefix: "de la", amount: "400 RON", suffix: "", eur: "≈ 80 EUR" },
          features: [
            "Puncte de lucru",
            "Schimbare / adăugare / autorizare coduri CAEN",
            "Suspendare / reluare activitate",
            "Cesiune părți sociale",
            "Dizolvare și lichidare",
            "Radiere firmă",
            "Schimbare administrator",
            "Adăugare / retragere asociați",
          ],
        },
      ],
    },
    process: {
      label: "Proces",
      title: "Cum funcționează",
      steps: [
        {
          title: "Trimite cererea",
          desc: "Completezi formularul și ne spui ce ai nevoie.",
        },
        {
          title: "Primești oferta în 24h",
          desc: "Îți trimitem o ofertă cu preț fix, totul inclus.",
        },
        {
          title: "Semnezi contractul",
          desc: "Semnăm contractul de sediu social sau de birou.",
        },
        {
          title: "Sediul social este activ",
          desc: "Folosești adresa pentru înregistrarea firmei.",
        },
      ],
    },
    faq: {
      label: "Întrebări frecvente",
      title: "Ai întrebări? Avem răspunsuri",
      items: [
        {
          q: "Care este diferența dintre un sediu social real și unul virtual?",
          a: "Un sediu social real înseamnă un birou fizic, cu spațiu pe care îl poți folosi și vizita. Noi oferim exclusiv birouri reale în București — nu căsuțe poștale virtuale.",
        },
        {
          q: "Pot înregistra firma la ONRC cu această adresă?",
          a: "Da. Adresa este un sediu social valid pentru înregistrarea la Oficiul Național al Registrului Comerțului (ONRC) și pentru toate instituțiile române.",
        },
        {
          q: "Trebuie să vin în România?",
          a: "Nu, nu este nevoie de prezența fizică. Totul se poate realiza de la distanță — ofertarea, contractarea și activarea sediului social. Te invităm totuși să vizitezi biroul oricând.",
        },
        {
          q: "Cât costă?",
          a: "Sediul social costă 250 RON/an pentru contracte de minimum 24 de luni, sau 300 RON pentru 12 luni — toate taxele incluse. Cu redactarea tuturor actelor (SRL, PFA, II etc.): de la 700 RON/an. Alte demersuri (puncte de lucru, coduri CAEN, cesiuni, radieri etc.): de la 400 RON. În plus, realizăm orice demers legal de care are nevoie firma ta, inclusiv contracte. Lucrăm cu preț fix, fără costuri ascunse.",
        },
        {
          q: "În ce limbi comunicați?",
          a: "Română, engleză, bulgară, sârbă și maghiară. Răspundem în limba în care ne scrii.",
        },
      ],
    },
    gdpr: {
      label: "GDPR",
      title: "Protecția datelor (GDPR)",
      items: [
        {
          title: "Ce date colectăm",
          desc: "Prin formularul de contact colectăm: nume, adresă de email, număr de telefon și mesajul tău.",
        },
        {
          title: "De ce le colectăm",
          desc: "Folosim datele exclusiv pentru a-ți răspunde la cererea de ofertă și pentru a pregăti documentele cerute.",
        },
        {
          title: "Cui le transmitem",
          desc: "Nu vindem și nu partajăm datele tale cu terți. Ele sunt procesate doar prin serviciul nostru de email, pentru transmiterea mesajelor.",
        },
        {
          title: "Cât timp le păstrăm",
          desc: "Păstrăm cererile doar cât este necesar pentru a-ți răspunde și a derula colaborarea.",
        },
        {
          title: "Drepturile tale",
          desc: "Conform GDPR, ai dreptul de acces, rectificare, ștergere și opoziție. Scrie-ne la uba.company1@gmail.com pentru orice solicitare privind datele tale.",
        },
        {
          title: "Module cookie",
          desc: "Site-ul nu folosește cookie-uri de urmărire. Salvăm doar limba preferată în browserul tău.",
        },
      ],
    },
    contact: {
      label: "Contact",
      title: "Solicită o ofertă",
      subtitle:
        "Completezi formularul și primești oferta cu preț fix în cel mult 24 de ore.",
      name: "Nume complet",
      email: "Email",
      phone: "Telefon",
      service: "Serviciu de interes",
      serviceOptions: [
        "Găzduire firmă",
        "Găzduire firmă + redactare acte",
        "Alte servicii",
        "Altceva",
      ],
      message: "Mesaj",
      messagePlaceholder: "Spune-ne pe scurt ce ai nevoie...",
      submit: "Trimite cererea",
      sending: "Se trimite...",
      success: "Cererea a fost trimisă! Răspundem în cel mult 24 de ore.",
      error: "A apărut o eroare. Te rugăm să încerci din nou.",
      validation: "Te rugăm să completezi corect toate câmpurile obligatorii.",
      emailInvalid: "Introdu o adresă de email validă (cu @).",
      phoneRequired: "Numărul de telefon este obligatoriu.",
      serviceRequired: "Alege un serviciu de interes.",
      messageShort: "Mesajul trebuie să aibă cel puțin 20 de caractere.",
      gdprConsent: "Am citit și accept",
      gdprLink: "politica de protecție a datelor (GDPR)",
      gdprRequired: "Trebuie să accepți politica de protecție a datelor.",
      chatTitle: "Asistent UBA",
      chatWelcome: "Bună! Întreabă-mă orice despre sediul social, prețuri sau serviciile noastre.",
      chatPlaceholder: "Scrie întrebarea ta...",
      chatSend: "Trimite",
      chatError: "A apărut o eroare. Încearcă din nou.",
      chatOpen: "Deschide asistentul",
    },
    whatsapp: {
      message: "Bună ziua! Doresc o ofertă pentru sediul social / birou în București.",
      hours: "Luni–Vineri: 9:00–17:00",
      label: "Scrie-ne pe WhatsApp",
      callLabel: "Sună-ne",
      phone: "+40 749 994 040",
    },
    footer: {
      tagline: "Domiciliu legal și birouri reale în București.",
      navTitle: "Navigare",
      contactTitle: "Contact",
      location: "București, România",
      rights: "Toate drepturile rezervate.",
    },
  },

  en: {
    docTitle: "UBA COMPANY — Your real registered office in Bucharest",
    nav: {
      services: "Services",
      whyUs: "Why us",
      pricing: "Pricing",
      process: "Process",
      faq: "FAQ",
      gdpr: "GDPR",
      contact: "Contact",
      cta: "Request a quote",
      menu: "Menu",
    },
    hero: {
      badge: "Bucharest · Romania",
      title: "Your company's real registered office,",
      titleAccent: "in the heart of Bucharest",
      subtitle:
        "A legal address with a real physical office in Bucharest — not virtual. Fixed all-inclusive price, no surprises. We reply within 24 hours, in your language.",
      ctaPrimary: "Request a quote",
      ctaSecondary: "See services",
      chips: [
        "Real office, not virtual",
        "Fixed all-inclusive price",
        "Reply within 24h",
      ],
      heroPrice: "from 250 RON/year · ≈ 50 EUR",
      promo: {
        offer: "OFFER",
        until: "until 01.01.2027",
        free: "FREE EORI CODE",
        withAny: "with any service",
      },
      imageAlt: "Modern office building",
    },
    video: {
      title: "How UBA COMPANY works",
    },
    services: {
      label: "Services",
      title: "Everything your company needs for a real registered office",
      subtitle:
        "From the legal address to the physical workspace — no virtual solutions.",
      highlight: {
        title: "Legal procedures & contracts",
        desc: "We handle any legal procedure your company needs — contracts, deeds and official documents — at a fixed price agreed up front.",
        cta: "Request a quote",
        list: [
          "Company dissolutions and strike-offs",
          "Share and full company transfers",
          "Changes and updates to company data",
          "CAEN code changes and additions",
        ],
      },
      items: [
        {
          title: "Legal registered address",
          desc: "A real legal address for registering your company with the ONRC, valid for all authorities.",
        },
        {
          title: "Real offices in Bucharest",
          desc: "Physical office spaces you can use by reservation. Prices based on the time you need — you only pay for what you use.",
        },
        {
          title: "Mail reception & handling",
          desc: "We receive, scan and forward your official correspondence at the real address.",
        },
        {
          title: "ONRC registration support",
          desc: "We guide you with the registered-office documents in your incorporation file.",
        },
      ],
    },
    whyUs: {
      label: "Why UBA COMPANY",
      title: "Three simple reasons",
      items: [
        {
          title: "Fixed price, all inclusive",
          desc: "You know exactly what you pay from the start. No hidden costs, no surprises.",
        },
        {
          title: "Reply within 24 hours, in your language",
          desc: "We answer in Romanian, English, Bulgarian, Serbian or Hungarian — within 24 hours.",
        },
        {
          title: "Real office, not virtual",
          desc: "Your registered office is a real physical office in Bucharest you can visit anytime.",
        },
      ],
    },
    pricing: {
      label: "Pricing",
      title: "Fixed price, all inclusive",
      subtitle:
        "Choose the right package and receive the exact quote within 24 hours.",
      priceLabel: "Fixed price on request",
      priceNote: "Price valid for contracts with a minimum duration of 24 months. Price for 12 months: 300 RON, all taxes included.",
      cta: "Request a quote",
      note: "Every quote is a fixed, all-inclusive price — no hidden costs.",
      note2: "Note: our prices do not include the fees charged by the ONRC.",
      plans: [
        {
          name: "Company hosting",
          desc: "Registered office for your company",
          price: { prefix: "from", amount: "250 RON", suffix: "/year", eur: "≈ 50 EUR/year" },
          features: [
            "Real legal address",
            "Mail reception",
            "ONRC-approved office lease contract",
          ],
        },
        {
          name: "Company hosting + document drafting",
          desc: "Document drafting included",
          price: { prefix: "from", amount: "700 RON", suffix: "/year", eur: "≈ 140 EUR/year" },
          features: [
            "Physical office in Bucharest",
            "Access to all official company documents",
            "Drafting of all documents for SRL, PFA, II etc.",
          ],
          popular: "Most chosen",
        },
        {
          name: "Other services we offer",
          desc: "Legal procedures on request",
          price: { prefix: "from", amount: "400 RON", suffix: "", eur: "≈ 80 EUR" },
          features: [
            "Work points (puncte de lucru)",
            "Change / add / authorise CAEN codes",
            "Suspension / resumption of activity",
            "Share transfer",
            "Dissolution and liquidation",
            "Company strike-off",
            "Change of administrator",
            "Adding / removing associates",
          ],
        },
      ],
    },
    process: {
      label: "Process",
      title: "How it works",
      steps: [
        {
          title: "Send your enquiry",
          desc: "Fill in the form and tell us what you need.",
        },
        {
          title: "Get a quote within 24h",
          desc: "We send you a fixed, all-inclusive offer.",
        },
        {
          title: "Sign the contract",
          desc: "We sign the registered-office or office agreement.",
        },
        {
          title: "Your office is active",
          desc: "Use the address to register your company.",
        },
      ],
    },
    faq: {
      label: "Frequently asked questions",
      title: "Questions? We have answers",
      items: [
        {
          q: "What is the difference between a real and a virtual registered office?",
          a: "A real registered office means a physical office — space you can actually use and visit. We only offer real offices in Bucharest, not virtual mailboxes.",
        },
        {
          q: "Can I register my company with the ONRC using this address?",
          a: "Yes. The address is a valid registered office for registration with the National Trade Register Office (ONRC) and all Romanian authorities.",
        },
        {
          q: "Do I need to travel to Romania?",
          a: "No, physical presence is not required. Everything can be done remotely — the quote, the contract and the activation of your registered office. You are still welcome to visit your office anytime.",
        },
        {
          q: "How much does it cost?",
          a: "The registered office costs 250 RON/year for contracts of at least 24 months, or 300 RON for 12 months — all taxes included. With drafting of all documents (SRL, PFA, II etc.): from 700 RON/year. Other procedures (work points, CAEN codes, share transfers, strike-offs etc.): from 400 RON. In addition, we handle any legal procedure your company needs, including contracts. Fixed prices, no hidden costs.",
        },
        {
          q: "Which languages do you speak?",
          a: "Romanian, English, Bulgarian, Serbian and Hungarian. We reply in the language you write to us.",
        },
      ],
    },
    gdpr: {
      label: "GDPR",
      title: "Data protection (GDPR)",
      items: [
        {
          title: "What data we collect",
          desc: "Through the contact form we collect: name, email address, phone number and your message.",
        },
        {
          title: "Why we collect it",
          desc: "We use your data solely to answer your quote request and to prepare the documents you ask for.",
        },
        {
          title: "Who we share it with",
          desc: "We do not sell or share your data with third parties. It is processed only through our email service, to deliver the messages.",
        },
        {
          title: "How long we keep it",
          desc: "We keep enquiries only as long as needed to reply to you and carry out the collaboration.",
        },
        {
          title: "Your rights",
          desc: "Under GDPR you have the right to access, rectification, erasure and objection. Write to uba.company1@gmail.com for any request regarding your data.",
        },
        {
          title: "Cookies",
          desc: "This site does not use tracking cookies. We only save your preferred language in your browser.",
        },
      ],
    },
    contact: {
      label: "Contact",
      title: "Request a quote",
      subtitle:
        "Fill in the form and receive the fixed-price quote within 24 hours.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      service: "Service of interest",
      serviceOptions: [
        "Company hosting",
        "Company hosting + document drafting",
        "Other services",
        "Something else",
      ],
      message: "Message",
      messagePlaceholder: "Tell us briefly what you need...",
      submit: "Send enquiry",
      sending: "Sending...",
      success: "Your enquiry has been sent! We reply within 24 hours.",
      error: "Something went wrong. Please try again.",
      validation: "Please fill in all required fields correctly.",
      emailInvalid: "Please enter a valid email address (with @).",
      phoneRequired: "Phone number is required.",
      serviceRequired: "Please choose a service of interest.",
      messageShort: "The message must be at least 20 characters.",
      gdprConsent: "I have read and accept",
      gdprLink: "the data protection policy (GDPR)",
      gdprRequired: "You must accept the data protection policy.",
      chatTitle: "UBA Assistant",
      chatWelcome: "Hi! Ask me anything about our registered office, prices or services.",
      chatPlaceholder: "Type your question...",
      chatSend: "Send",
      chatError: "Something went wrong. Please try again.",
      chatOpen: "Open the assistant",
    },
    whatsapp: {
      message: "Hello! I would like a quote for a registered office in Bucharest.",
      hours: "Mon–Fri: 9:00–17:00",
      label: "Chat with us on WhatsApp",
      callLabel: "Call us",
      phone: "+40 749 994 040",
    },
    footer: {
      tagline: "Legal address and real offices in Bucharest.",
      navTitle: "Navigation",
      contactTitle: "Contact",
      location: "Bucharest, Romania",
      rights: "All rights reserved.",
    },
  },

  bg: {
    docTitle: "UBA COMPANY — Реалното седалище на вашата фирма в Букурещ",
    nav: {
      services: "Услуги",
      whyUs: "Защо ние",
      pricing: "Цени",
      process: "Процес",
      faq: "Въпроси",
      gdpr: "GDPR",
      contact: "Контакт",
      cta: "Поискайте оферта",
      menu: "Меню",
    },
    hero: {
      badge: "Букурещ · Румъния",
      title: "Реалното регистрирано седалище на вашата фирма,",
      titleAccent: "в сърцето на Букурещ",
      subtitle:
        "Законен адрес с реален физически офис в Букурещ — не виртуален. Фиксирана цена с всичко включено, без изненади. Отговаряме до 24 часа, на вашия език.",
      ctaPrimary: "Поискайте оферта",
      ctaSecondary: "Вижте услугите",
      chips: [
        "Реален офис, не виртуален",
        "Фиксирана цена, всичко включено",
        "Отговор до 24 часа",
      ],
      heroPrice: "от 250 RON/година · ≈ 50 EUR",
      promo: {
        offer: "ОФЕРТА",
        until: "до 01.01.2027",
        free: "БЕЗПЛАТЕН EORI КОД",
        withAny: "с всяка услуга",
      },
      imageAlt: "Модерна офис сграда",
    },
    video: {
      title: "Как работи UBA COMPANY",
    },
    services: {
      label: "Услуги",
      title: "Всичко необходимо на фирмата ви за реално седалище",
      subtitle:
        "От юридическия адрес до физическото работно пространство — без виртуални решения.",
      highlight: {
        title: "Правни процедури и договори",
        desc: "Извършваме всяка правна процедура, от която фирмата ви се нуждае — договори, актове и официални документи — с фиксирана цена, уговорена предварително.",
        cta: "Поискайте оферта",
        list: [
          "Закриване и заличаване на фирми",
          "Прехвърляне на дялове и цели фирми",
          "Промени и актуализации на фирмените данни",
          "Промени и добавяния на кодове CAEN",
        ],
      },
      items: [
        {
          title: "Юридически адрес (седалище)",
          desc: "Реален законен адрес за регистрация на фирмата ви в ONRC, валиден пред всички институции.",
        },
        {
          title: "Реални офиси в Букурещ",
          desc: "Физически офис пространства, които можете да използвате с резервация. Цени според необходимото време — плащате само това, което използвате.",
        },
        {
          title: "Приемане на кореспонденция",
          desc: "Получаваме, сканираме и ви препращаме официалната кореспонденция на реалния адрес.",
        },
        {
          title: "Подкрепа при регистрация в ONRC",
          desc: "Съдействаме ви с документите за седалището в регистрационното досие.",
        },
      ],
    },
    whyUs: {
      label: "Защо UBA COMPANY",
      title: "Три прости причини",
      items: [
        {
          title: "Фиксирана цена, всичко включено",
          desc: "Знаете точно колко плащате от самото начало. Без скрити разходи, без изненади.",
        },
        {
          title: "Отговор до 24 часа, на вашия език",
          desc: "Отговаряме на румънски, английски, български, сръбски или унгарски — до 24 часа.",
        },
        {
          title: "Реален офис, не виртуален",
          desc: "Седалището е реален физически офис в Букурещ, който можете да посетите по всяко време.",
        },
      ],
    },
    pricing: {
      label: "Цени",
      title: "Фиксирана цена, всичко включено",
      subtitle:
        "Изберете подходящия пакет и получете точната оферта до 24 часа.",
      priceLabel: "Фиксирана цена при запитване",
      priceNote: "Цената важи за договори с минимална продължителност 24 месеца. Цена за 12 месеца: 300 RON, с включени всички данъци.",
      cta: "Поискайте оферта",
      note: "Всяка оферта е с фиксирана цена, всичко включено — без скрити разходи.",
      note2: "Забележка: в нашите цени не са включени таксите, начислявани от ONRC.",
      plans: [
        {
          name: "Хостинг за фирми",
          desc: "Седалище за вашата фирма",
          price: { prefix: "от", amount: "250 RON", suffix: "/година", eur: "≈ 50 EUR/година" },
          features: [
            "Реален юридически адрес",
            "Приемане на кореспонденция",
            "Договор за наем на седалище, одобрен от ONRC",
          ],
        },
        {
          name: "Хостинг за фирми + изготвяне на документи",
          desc: "Включено изготвяне на документи",
          price: { prefix: "от", amount: "700 RON", suffix: "/година", eur: "≈ 140 EUR/година" },
          features: [
            "Физически офис в Букурещ",
            "Достъп до цялата официална документация на фирмата",
            "Изготвяне на всички документи за SRL, PFA, II и др.",
          ],
          popular: "Най-избиран",
        },
        {
          name: "Други услуги, които предлагаме",
          desc: "Правни процедури при запитване",
          price: { prefix: "от", amount: "400 RON", suffix: "", eur: "≈ 80 EUR" },
          features: [
            "Работни точки (puncte de lucru)",
            "Промяна / добавяне / разрешаване на кодове CAEN",
            "Спиране / подновяване на дейността",
            "Прехвърляне на дялове",
            "Закриване и ликвидация",
            "Заличаване на фирма",
            "Смяна на управител",
            "Добавяне / оттегляне на съдружници",
          ],
        },
      ],
    },
    process: {
      label: "Процес",
      title: "Как работи",
      steps: [
        {
          title: "Изпратете запитване",
          desc: "Попълнете формуляра и ни кажете от какво се нуждаете.",
        },
        {
          title: "Получете оферта до 24ч",
          desc: "Изпращаме ви оферта с фиксирана цена, всичко включено.",
        },
        {
          title: "Подпишете договора",
          desc: "Подписваме договора за седалище или офис.",
        },
        {
          title: "Седалището е активно",
          desc: "Използвате адреса за регистрация на фирмата.",
        },
      ],
    },
    faq: {
      label: "Често задавани въпроси",
      title: "Имате въпроси? Имаме отговори",
      items: [
        {
          q: "Каква е разликата между реално и виртуално седалище?",
          a: "Реалното седалище означава физически офис — пространство, което можете реално да използвате и посещавате. Предлагаме само реални офиси в Букурещ, не виртуални пощенски кутии.",
        },
        {
          q: "Мога ли да регистрирам фирмата си в ONRC с този адрес?",
          a: "Да. Адресът е валидно седалище за регистрация в Националния търговски регистър (ONRC) и пред всички румънски институции.",
        },
        {
          q: "Трябва ли да пътувам до Румъния?",
          a: "Не, физическо присъствие не е необходимо. Всичко може да се извърши дистанционно — офертата, договорът и активирането на седалището. Въпреки това сте добре дошли да посетите офиса си по всяко време.",
        },
        {
          q: "Колко струва?",
          a: "Юридическият адрес струва 250 RON годишно при договори за минимум 24 месеца или 300 RON за 12 месеца — с включени всички данъци. С изготвяне на всички документи (SRL, PFA, II и др.): от 700 RON/година. Други процедури (работни точки, кодове CAEN, прехвърляния, заличавания и др.): от 400 RON. Освен това извършваме всяка правна процедура, от която фирмата ви се нуждае, включително договори. Фиксирани цени, без скрити разходи.",
        },
        {
          q: "На какви езици общувате?",
          a: "Румънски, английски, български, сръбски и унгарски. Отговаряме на езика, на който ни пишете.",
        },
      ],
    },
    gdpr: {
      label: "GDPR",
      title: "Защита на данните (GDPR)",
      items: [
        {
          title: "Какви данни събираме",
          desc: "Чрез формуляра за контакт събираме: име, имейл адрес, телефонен номер и вашето съобщение.",
        },
        {
          title: "Защо ги събираме",
          desc: "Използваме данните единствено, за да отговорим на вашето запитване за оферта и да подготвим исканите документи.",
        },
        {
          title: "На кого ги предоставяме",
          desc: "Не продаваме и не споделяме данните ви с трети страни. Те се обработват само чрез нашата имейл услуга, за доставяне на съобщенията.",
        },
        {
          title: "Колко време ги пазим",
          desc: "Пазим запитванията само толкова, колкото е необходимо, за да ви отговорим и да осъществим сътрудничеството.",
        },
        {
          title: "Вашите права",
          desc: "Съгласно GDPR имате право на достъп, корекция, изтриване и възражение. Пишете ни на uba.company1@gmail.com за всяко искане, свързано с данните ви.",
        },
        {
          title: "Бисквитки",
          desc: "Този сайт не използва бисквитки за проследяване. Запазваме само предпочитания от вас език в браузъра ви.",
        },
      ],
    },
    contact: {
      label: "Контакт",
      title: "Поискайте оферта",
      subtitle:
        "Попълнете формуляра и получете офертата с фиксирана цена до 24 часа.",
      name: "Пълно име",
      email: "Имейл",
      phone: "Телефон",
      service: "Услуга",
      serviceOptions: [
        "Хостинг за фирми",
        "Хостинг за фирми + изготвяне на документи",
        "Други услуги",
        "Нещо друго",
      ],
      message: "Съобщение",
      messagePlaceholder: "Кажете ни накратко от какво се нуждаете...",
      submit: "Изпратете запитването",
      sending: "Изпраща се...",
      success: "Запитването е изпратено! Отговаряме до 24 часа.",
      error: "Възникна грешка. Моля, опитайте отново.",
      validation: "Моля, попълнете правилно всички задължителни полета.",
      emailInvalid: "Моля, въведете валиден имейл адрес (с @).",
      phoneRequired: "Телефонният номер е задължителен.",
      serviceRequired: "Моля, изберете услуга.",
      messageShort: "Съобщението трябва да е поне 20 знака.",
      gdprConsent: "Прочетох и приемам",
      gdprLink: "политиката за защита на данните (GDPR)",
      gdprRequired: "Трябва да приемете политиката за защита на данните.",
      chatTitle: "UBA Асистент",
      chatWelcome: "Здравейте! Питайте ме за седалището, цените или услугите ни.",
      chatPlaceholder: "Напишете въпроса си...",
      chatSend: "Изпрати",
      chatError: "Възникна грешка. Опитайте отново.",
      chatOpen: "Отворете асистента",
    },
    whatsapp: {
      message: "Здравейте! Бих искал оферта за юридически адрес в Букурещ.",
      hours: "Пон–Пет: 9:00–17:00",
      label: "Пишете ни в WhatsApp",
      callLabel: "Обадете ни се",
      phone: "+40 749 994 040",
    },
    footer: {
      tagline: "Юридически адрес и реални офиси в Букурещ.",
      navTitle: "Навигация",
      contactTitle: "Контакт",
      location: "Букурещ, Румъния",
      rights: "Всички права запазени.",
    },
  },

  sr: {
    docTitle: "UBA COMPANY — Pravo sedište vaše firme u Bukureštu",
    nav: {
      services: "Usluge",
      whyUs: "Zašto mi",
      pricing: "Cene",
      process: "Proces",
      faq: "Pitanja",
      gdpr: "GDPR",
      contact: "Kontakt",
      cta: "Zatražite ponudu",
      menu: "Meni",
    },
    hero: {
      badge: "Bukurešt · Rumunija",
      title: "Pravo registrovano sedište vaše firme,",
      titleAccent: "u srcu Bukurešta",
      subtitle:
        "Pravna adresa sa stvarnom fizičkom kancelarijom u Bukureštu — ne virtuelnom. Fiksna cena sa svim uključenim, bez iznenađenja. Odgovaramo u roku od 24 sata, na vašem jeziku.",
      ctaPrimary: "Zatražite ponudu",
      ctaSecondary: "Pogledajte usluge",
      chips: [
        "Stvarna kancelarija, ne virtuelna",
        "Fiksna cena, sve uključeno",
        "Odgovor u roku od 24h",
      ],
      heroPrice: "od 250 RON/godišnje · ≈ 50 EUR",
      promo: {
        offer: "PONUDA",
        until: "do 01.01.2027",
        free: "BESPLATAN EORI KOD",
        withAny: "uz svaku uslugu",
      },
      imageAlt: "Moderna poslovna zgrada",
    },
    video: {
      title: "Kako funkcioniše UBA COMPANY",
    },
    services: {
      label: "Usluge",
      title: "Sve što je vašoj firmi potrebno za stvarno sedište",
      subtitle:
        "Od pravne adrese do fizičkog radnog prostora — bez virtuelnih rešenja.",
      highlight: {
        title: "Pravni postupci i ugovori",
        desc: "Obavljamo svaki pravni postupak koji je vašoj firmi potreban — ugovore, akte i zvanična dokumenta — po fiksnoj ceni dogovorenoj unapred.",
        cta: "Zatražite ponudu",
        list: [
          "Zatvaranje i brisanje firmi",
          "Prenos udela i celih firmi",
          "Izmene i ažuriranje podataka firme",
          "Izmene i dodavanje CAEN kodova",
        ],
      },
      items: [
        {
          title: "Pravna adresa (sedište firme)",
          desc: "Stvarna zakonska adresa za registraciju vaše firme u ONRC, važeća za sve institucije.",
        },
        {
          title: "Stvarne kancelarije u Bukureštu",
          desc: "Fizički kancelarijski prostori koje možete koristiti uz rezervaciju. Cene prema potrebnom vremenu — plaćate samo onoliko koliko koristite.",
        },
        {
          title: "Prijem pošte i prepiske",
          desc: "Primamo, skeniramo i vam prosleđujemo službenu poštu na stvarnoj adresi.",
        },
        {
          title: "Podrška za registraciju u ONRC",
          desc: "Pomažemo vam sa dokumentacijom o sedištu u registracionom dosijeu.",
        },
      ],
    },
    whyUs: {
      label: "Zašto UBA COMPANY",
      title: "Tri jednostavna razloga",
      items: [
        {
          title: "Fiksna cena, sve uključeno",
          desc: "Znate tačno koliko plaćate od samog početka. Bez skrivenih troškova, bez iznenađenja.",
        },
        {
          title: "Odgovor u roku od 24 sata, na vašem jeziku",
          desc: "Odgovaramo na rumunskom, engleskom, bugarskom, srpskom ili mađarskom — u roku od 24 sata.",
        },
        {
          title: "Stvarna kancelarija, ne virtuelna",
          desc: "Sedište je stvarna fizička kancelarija u Bukureštu koju možete posetiti u bilo kom trenutku.",
        },
      ],
    },
    pricing: {
      label: "Cene",
      title: "Fiksna cena, sve uključeno",
      subtitle:
        "Izaberite odgovarajući paket i dobijte tačnu ponudu u roku od 24 sata.",
      priceLabel: "Fiksna cena na upit",
      priceNote: "Cena važi za ugovore sa minimalnim trajanjem od 24 meseca. Cena za 12 meseci: 300 RON, sa svim uključenim porezima.",
      cta: "Zatražite ponudu",
      note: "Svaka ponuda je sa fiksnom cenom, sve uključeno — bez skrivenih troškova.",
      note2: "Napomena: u naše cene nisu uključene takse koje naplaćuje ONRC.",
      plans: [
        {
          name: "Hostovanje firme",
          desc: "Sedište za vašu firmu",
          price: { prefix: "od", amount: "250 RON", suffix: "/godišnje", eur: "≈ 50 EUR/godišnje" },
          features: [
            "Stvarna pravna adresa",
            "Prijem pošte",
            "Ugovor o zakupu sedišta odobren od ONRC",
          ],
        },
        {
          name: "Hostovanje firme + sastavljanje dokumenata",
          desc: "Sastavljanje dokumenata uključeno",
          price: { prefix: "od", amount: "700 RON", suffix: "/godišnje", eur: "≈ 140 EUR/godišnje" },
          features: [
            "Fizička kancelarija u Bukureštu",
            "Pristup svoj zvaničnoj dokumentaciji firme",
            "Sastavljanje svih dokumenata za SRL, PFA, II itd.",
          ],
          popular: "Najčešći izbor",
        },
        {
          name: "Ostale usluge koje nudimo",
          desc: "Pravni postupci na upit",
          price: { prefix: "od", amount: "400 RON", suffix: "", eur: "≈ 80 EUR" },
          features: [
            "Radne tačke (puncte de lucru)",
            "Izmena / dodavanje / odobrenje CAEN kodova",
            "Obustava / nastavak delatnosti",
            "Prenos udela",
            "Zatvaranje i likvidacija",
            "Brisanje firme",
            "Promena administratora",
            "Dodavanje / povlačenje ortaka",
          ],
        },
      ],
    },
    process: {
      label: "Proces",
      title: "Kako funkcioniše",
      steps: [
        {
          title: "Pošaljite upit",
          desc: "Popunite formular i recite nam šta vam treba.",
        },
        {
          title: "Dobijte ponudu za 24h",
          desc: "Šaljemo vam ponudu sa fiksnom cenom, sve uključeno.",
        },
        {
          title: "Potpišite ugovor",
          desc: "Potpisujemo ugovor o sedištu ili kancelariji.",
        },
        {
          title: "Sedište je aktivno",
          desc: "Koristite adresu za registraciju firme.",
        },
      ],
    },
    faq: {
      label: "Često postavljana pitanja",
      title: "Imate pitanja? Imamo odgovore",
      items: [
        {
          q: "Koja je razlika između stvarnog i virtuelnog sedišta?",
          a: "Stvarno sedište znači fizičku kancelariju — prostor koji stvarno možete koristiti i posećivati. Nudimo isključivo stvarne kancelarije u Bukureštu, ne virtuelne poštanske sandučiće.",
        },
        {
          q: "Mogu li da registrujem firmu u ONRC sa ovom adresom?",
          a: "Da. Adresa je važeće sedište za registraciju u Nacionalnom registru privrednih subjekata (ONRC) i za sve rumunske institucije.",
        },
        {
          q: "Da li moram da putujem u Rumuniju?",
          a: "Ne, fizičko prisustvo nije potrebno. Sve se može obaviti na daljinu — ponuda, ugovor i aktivacija sedišta. Ipak, uvek ste dobrodošli da posetite svoju kancelariju.",
        },
        {
          q: "Koliko košta?",
          a: "Pravna adresa košta 250 RON godišnje za ugovore od najmanje 24 meseca, ili 300 RON za 12 meseci — sa svim uključenim porezima. Sa sastavljanjem svih dokumenata (SRL, PFA, II itd.): od 700 RON/godišnje. Ostali postupci (radne tačke, CAEN kodovi, prenosi, brisanja itd.): od 400 RON. Pored toga, obavljamo svaki pravni postupak koji je vašoj firmi potreban, uključujući ugovore. Fiksne cene, bez skrivenih troškova.",
        },
        {
          q: "Na kojim jezicima komunicirate?",
          a: "Rumunski, engleski, bugarski, srpski i mađarski. Odgovaramo na jeziku na kojem nam pišete.",
        },
      ],
    },
    gdpr: {
      label: "GDPR",
      title: "Zaštita podataka (GDPR)",
      items: [
        {
          title: "Koje podatke prikupljamo",
          desc: "Kroz kontakt formular prikupljamo: ime, imejl adresu, broj telefona i vašu poruku.",
        },
        {
          title: "Zašto ih prikupljamo",
          desc: "Podatke koristimo isključivo da odgovorimo na vaš upit za ponudu i pripremimo traženu dokumentaciju.",
        },
        {
          title: "Kome ih prosleđujemo",
          desc: "Ne prodajemo i ne delimo vaše podatke sa trećim stranama. Obrađuju se samo putem naše imejl usluge, radi dostavljanja poruka.",
        },
        {
          title: "Koliko dugo ih čuvamo",
          desc: "Upite čuvamo samo onoliko koliko je potrebno da vam odgovorimo i ostvarimo saradnju.",
        },
        {
          title: "Vaša prava",
          desc: "Prema GDPR imate pravo pristupa, ispravke, brisanja i prigovora. Pišite nam na uba.company1@gmail.com za svaki zahtev u vezi sa vašim podacima.",
        },
        {
          title: "Kolačići",
          desc: "Ova stranica ne koristi kolačiće za praćenje. Čuvamo samo vaš izabrani jezik u pretraživaču.",
        },
      ],
    },
    contact: {
      label: "Kontakt",
      title: "Zatražite ponudu",
      subtitle:
        "Popunite formular i dobijte ponudu sa fiksnom cenom u roku od 24 sata.",
      name: "Ime i prezime",
      email: "Imejl",
      phone: "Telefon",
      service: "Usluga",
      serviceOptions: [
        "Hostovanje firme",
        "Hostovanje firme + sastavljanje dokumenata",
        "Ostale usluge",
        "Nešto drugo",
      ],
      message: "Poruka",
      messagePlaceholder: "Ukratko nam recite šta vam treba...",
      submit: "Pošaljite upit",
      sending: "Slanje...",
      success: "Upit je poslat! Odgovaramo u roku od 24 sata.",
      error: "Došlo je do greške. Molimo pokušajte ponovo.",
      validation: "Molimo ispravno popunite sva obavezna polja.",
      emailInvalid: "Unesite važeću imejl adresu (sa @).",
      phoneRequired: "Broj telefona je obavezan.",
      serviceRequired: "Izaberite uslugu.",
      messageShort: "Poruka mora imati najmanje 20 karaktera.",
      gdprConsent: "Pročitao/la sam i prihvatam",
      gdprLink: "politiku zaštite podataka (GDPR)",
      gdprRequired: "Morate prihvatiti politiku zaštite podataka.",
      chatTitle: "UBA Asistent",
      chatWelcome: "Zdravo! Pitajte me bilo šta o sedištu, cenama ili našim uslugama.",
      chatPlaceholder: "Napišite vaše pitanje...",
      chatSend: "Pošalji",
      chatError: "Došlo je do greške. Pokušajte ponovo.",
      chatOpen: "Otvorite asistenta",
    },
    whatsapp: {
      message: "Zdravo! Želeo bih ponudu za registrovano sedište u Bukureštu.",
      hours: "Pon–Pet: 9:00–17:00",
      label: "Pišite nam na WhatsApp",
      callLabel: "Pozovite nas",
      phone: "+40 749 994 040",
    },
    footer: {
      tagline: "Pravna adresa i stvarne kancelarije u Bukureštu.",
      navTitle: "Navigacija",
      contactTitle: "Kontakt",
      location: "Bukurešt, Rumunija",
      rights: "Sva prava zadržana.",
    },
  },

  hu: {
    docTitle: "UBA COMPANY — Cége valódi székhelye Bukarestben",
    nav: {
      services: "Szolgáltatások",
      whyUs: "Miért mi",
      pricing: "Árak",
      process: "Folyamat",
      faq: "Kérdések",
      gdpr: "GDPR",
      contact: "Kapcsolat",
      cta: "Kérjen ajánlatot",
      menu: "Menü",
    },
    hero: {
      badge: "Bukarest · Románia",
      title: "Cége valódi bejegyzett székhelye,",
      titleAccent: "Bukarest szívében",
      subtitle:
        "Jogi cím valódi, fizikai irodával Bukarestben — nem virtuális. Fix, mindent magában foglaló ár, meglepetések nélkül. 24 órán belül válaszolunk, az Ön nyelvén.",
      ctaPrimary: "Kérjen ajánlatot",
      ctaSecondary: "Szolgáltatások",
      chips: [
        "Valódi iroda, nem virtuális",
        "Fix ár, mindennel együtt",
        "Válasz 24 órán belül",
      ],
      heroPrice: "250 RON/év-től · ≈ 50 EUR",
      promo: {
        offer: "AJÁNLAT",
        until: "2027.01.01-ig",
        free: "INGYENES EORI KÓD",
        withAny: "bármely szolgáltatáshoz",
      },
      imageAlt: "Modern irodaház",
    },
    video: {
      title: "Hogyan működik a UBA COMPANY",
    },
    services: {
      label: "Szolgáltatások",
      title: "Minden, amire cégének szüksége van egy valódi székhelyhez",
      subtitle:
        "A jogi címtől a fizikai munkatérig — virtuális megoldások nélkül.",
      highlight: {
        title: "Jogi ügyintézés és szerződések",
        desc: "Elvégezzük minden jogi ügyintézést, amire cégének szüksége van — szerződések, okiratok és hivatalos dokumentumok —, előre egyeztetett fix áron.",
        cta: "Kérjen ajánlatot",
        list: [
          "Cégek feloszlatása és törlése",
          "Üzletrész- és teljes cégátruházások",
          "A cég adatainak módosítása és frissítése",
          "CAEN kódok módosítása és hozzáadása",
        ],
      },
      items: [
        {
          title: "Jogi cím (székhely)",
          desc: "Valódi jogi cím cége ONRC-be történő bejegyzéséhez, amely minden hatóság előtt érvényes.",
        },
        {
          title: "Valódi irodák Bukarestben",
          desc: "Fizikai irodaterek, amelyeket foglalással használhat. Árak a szükséges idő alapján — csak annyit fizet, amennyit igénybe vesz.",
        },
        {
          title: "Posta átvétele és kezelése",
          desc: "A valódi címen átvesszük, beszkenneljük és továbbítjuk Önnek a hivatalos levelezést.",
        },
        {
          title: "ONRC regisztrációs támogatás",
          desc: "Segítünk a székhelyhez kapcsolódó dokumentumokkal a bejegyzési aktában.",
        },
      ],
    },
    whyUs: {
      label: "Miért a UBA COMPANY",
      title: "Három egyszerű ok",
      items: [
        {
          title: "Fix ár, mindennel együtt",
          desc: "Kezdettől fogva pontosan tudja, mennyit fizet. Rejtett költségek és meglepetések nélkül.",
        },
        {
          title: "Válasz 24 órán belül, az Ön nyelvén",
          desc: "Románul, angolul, bolgárul, szerbül vagy magyarul válaszolunk — 24 órán belül.",
        },
        {
          title: "Valódi iroda, nem virtuális",
          desc: "A székhely egy valódi fizikai iroda Bukarestben, amelyet bármikor meglátogathat.",
        },
      ],
    },
    pricing: {
      label: "Árak",
      title: "Fix ár, mindennel együtt",
      subtitle:
        "Válassza ki a megfelelő csomagot, és 24 órán belül megkapja a pontos ajánlatot.",
      priceLabel: "Fix ár kérésre",
      priceNote: "Az ár minimum 24 hónapos szerződésekre érvényes. 12 hónapos ár: 300 RON, minden adót tartalmaz.",
      cta: "Kérjen ajánlatot",
      note: "Minden ajánlat fix, mindent magában foglaló árú — rejtett költségek nélkül.",
      note2: "Megjegyzés: áraink nem tartalmazzák az ONRC által felszámított díjakat.",
      plans: [
        {
          name: "Céghoszting",
          desc: "Székhely cége számára",
          price: { prefix: "", amount: "250 RON", suffix: "/év-től", eur: "≈ 50 EUR/év" },
          features: [
            "Valódi jogi cím",
            "Posta átvétele",
            "ONRC által jóváhagyott székhely-bérleti szerződés",
          ],
        },
        {
          name: "Céghoszting + okiratszerkesztés",
          desc: "Az okiratok szerkesztése benne van",
          price: { prefix: "", amount: "700 RON", suffix: "/év-től", eur: "≈ 140 EUR/év-től" },
          features: [
            "Fizikai iroda Bukarestben",
            "Hozzáférés a cég összes hivatalos dokumentumához",
            "Az összes okirat szerkesztése SRL, PFA, II stb. számára",
          ],
          popular: "Legnépszerűbb",
        },
        {
          name: "Egyéb szolgáltatásaink",
          desc: "Jogi ügyintézés kérésre",
          price: { prefix: "", amount: "400 RON", suffix: "-tól", eur: "≈ 80 EUR-tól" },
          features: [
            "Munkapontok (puncte de lucru)",
            "CAEN kódok módosítása / hozzáadása / engedélyezése",
            "Tevékenység felfüggesztése / újraindítása",
            "Üzletrész-átruházás",
            "Feloszlatás és felszámolás",
            "Cég törlése",
            "Ügyvezető cseréje",
            "Tagok hozzáadása / kivonása",
          ],
        },
      ],
    },
    process: {
      label: "Folyamat",
      title: "Hogyan működik",
      steps: [
        {
          title: "Küldje el megkeresését",
          desc: "Töltse ki az űrlapot, és mondja el, mire van szüksége.",
        },
        {
          title: "Ajánlat 24 órán belül",
          desc: "Fix, mindent magában foglaló ajánlatot küldünk Önnek.",
        },
        {
          title: "Szerződés aláírása",
          desc: "Aláírjuk a székhely- vagy irodaszerződést.",
        },
        {
          title: "A székhely aktív",
          desc: "Használja a címet cége bejegyzéséhez.",
        },
      ],
    },
    faq: {
      label: "Gyakori kérdések",
      title: "Kérdése van? Nekünk válaszunk van",
      items: [
        {
          q: "Mi a különbség a valódi és a virtuális székhely között?",
          a: "A valódi székhely fizikai irodát jelent — olyan teret, amelyet ténylegesen használhat és meglátogathat. Mi kizárólag valódi irodákat kínálunk Bukarestben, nem virtuális postaládákat.",
        },
        {
          q: "Bejegyezhetem a cégemet az ONRC-be ezzel a címmel?",
          a: "Igen. A cím érvényes székhely az Országos Kereskedelmi Nyilvántartásba (ONRC) és minden román hatóság előtt történő bejegyzéshez.",
        },
        {
          q: "El kell utaznom Romániába?",
          a: "Nem, személyes jelenlét nem szükséges. Minden elvégezhető távolról — az ajánlat, a szerződés és a székhely aktiválása. Az irodáját azonban bármikor szívesen látjuk.",
        },
        {
          q: "Mennyibe kerül?",
          a: "A székhely 250 RON/év minimum 24 hónapos szerződés esetén, vagy 300 RON 12 hónapra — minden adóval együtt. Az összes okirat szerkesztésével (SRL, PFA, II stb.): 700 RON/év-től. Egyéb ügyintézések (munkapontok, CAEN kódok, átruházások, törlések stb.): 400 RON-tól. Ezen felül elvégezzük minden jogi ügyintézést, amire cégének szüksége van, beleértve a szerződéseket is. Fix árak, rejtett költségek nélkül.",
        },
        {
          q: "Milyen nyelveken kommunikálnak?",
          a: "Románul, angolul, bolgárul, szerbül és magyarul. Azon a nyelven válaszolunk, amelyen ír nekünk.",
        },
      ],
    },
    gdpr: {
      label: "GDPR",
      title: "Adatvédelem (GDPR)",
      items: [
        {
          title: "Milyen adatokat gyűjtünk",
          desc: "A kapcsolatfelvételi űrlapon keresztül a következőket gyűjtjük: név, e-mail cím, telefonszám és az Ön üzenete.",
        },
        {
          title: "Miért gyűjtjük",
          desc: "Az adatokat kizárólag az ajánlatkérés megválaszolására és a kért dokumentumok elkészítésére használjuk.",
        },
        {
          title: "Kinek adjuk tovább",
          desc: "Adatait nem adjuk el és nem osztjuk meg harmadik felekkel. Csak az e-mail szolgáltatásunkon keresztül dolgozzuk fel, az üzenetek kézbesítéséhez.",
        },
        {
          title: "Mennyi ideig őrizzük",
          desc: "A megkereséseket csak addig őrizzük, amíg a válaszadáshoz és az együttműködéshez szükséges.",
        },
        {
          title: "Az Ön jogai",
          desc: "A GDPR értelmében joga van a hozzáféréshez, helyesbítéshez, törléshez és tiltakozáshoz. Írjon nekünk a uba.company1@gmail.com címre bármilyen adatvédelmi kéréssel.",
        },
        {
          title: "Sütik",
          desc: "Ez az oldal nem használ nyomkövető sütiket. Csak az Ön által választott nyelvet mentjük el a böngészőjében.",
        },
      ],
    },
    contact: {
      label: "Kapcsolat",
      title: "Kérjen ajánlatot",
      subtitle:
        "Töltse ki az űrlapot, és 24 órán belül megkapja a fix áras ajánlatot.",
      name: "Teljes név",
      email: "E-mail",
      phone: "Telefon",
      service: "Szolgáltatás",
      serviceOptions: [
        "Céghoszting",
        "Céghoszting + okiratszerkesztés",
        "Egyéb szolgáltatások",
        "Valami más",
      ],
      message: "Üzenet",
      messagePlaceholder: "Mondja el röviden, mire van szüksége...",
      submit: "Megkeresés elküldése",
      sending: "Küldés...",
      success: "Megkeresése elküldve! 24 órán belül válaszolunk.",
      error: "Hiba történt. Kérjük, próbálja újra.",
      validation: "Kérjük, töltsön ki helyesen minden kötelező mezőt.",
      emailInvalid: "Kérjük, adjon meg érvényes e-mail címet (@ jellel).",
      phoneRequired: "A telefonszám megadása kötelező.",
      serviceRequired: "Kérjük, válasszon szolgáltatást.",
      messageShort: "Az üzenetnek legalább 20 karakterből kell állnia.",
      gdprConsent: "Elolvastam és elfogadom",
      gdprLink: "az adatvédelmi irányelvet (GDPR)",
      gdprRequired: "El kell fogadnia az adatvédelmi irányelvet.",
      chatTitle: "UBA Asszisztens",
      chatWelcome: "Üdvözlöm! Kérdezzen a székhelyről, árakról vagy szolgáltatásainkról.",
      chatPlaceholder: "Írja be a kérdését...",
      chatSend: "Küldés",
      chatError: "Hiba történt. Kérjük, próbálja újra.",
      chatOpen: "Asszisztens megnyitása",
    },
    whatsapp: {
      message: "Jó napot! Ajánlatot szeretnék kérni bukaresti székhelyszolgáltatásra.",
      hours: "Hétfő–Péntek: 9:00–17:00",
      label: "Írjon nekünk WhatsAppon",
      callLabel: "Hívjon minket",
      phone: "+40 749 994 040",
    },
    footer: {
      tagline: "Jogi cím és valódi irodák Bukarestben.",
      navTitle: "Navigáció",
      contactTitle: "Kapcsolat",
      location: "Bukarest, Románia",
      rights: "Minden jog fenntartva.",
    },
  },
};

export const markets = {
  bulgaria: {
    lang: "bg",
    docTitle: "UBA COMPANY — Седалище в Букурещ за български фирми",
    badge: "За български фирми",
    title: "Регистрирано седалище в Букурещ",
    titleAccent: "за вашата българска фирма",
    subtitle:
      "Реален физически офис в Букурещ — не виртуален. Обслужваме ви изцяло на български и отговаряме до 24 часа.",
    heroPrice: "от 250 RON/година · ≈ 50 EUR",
    points: [
      "Всички документи и комуникация на български език",
      "Валидно седалище за ONRC и всички румънски институции",
      "Получаваме и ви препращаме кореспонденцията",
      "Лесен достъп от България — посетете офиса си по всяко време",
    ],
    ctaPrimary: "Поискайте оферта на български",
    ctaSecondary: "Вижте услугите",
    imageAlt: "Реален офис на UBA COMPANY в Букурещ",
  },
  serbia: {
    lang: "sr",
    docTitle: "UBA COMPANY — Sedište u Bukureštu za srpske firme",
    badge: "Za srpske firme",
    title: "Registrovano sedište u Bukureštu",
    titleAccent: "za vašu srpsku firmu",
    subtitle:
      "Stvarna fizička kancelarija u Bukureštu — ne virtuelna. Komuniciramo u potpunosti na srpskom i odgovaramo u roku od 24 sata.",
    heroPrice: "od 250 RON/godišnje · ≈ 50 EUR",
    points: [
      "Sva dokumentacija i komunikacija na srpskom jeziku",
      "Važeće sedište za ONRC i sve rumunske institucije",
      "Primamo i prosleđujemo vašu službenu poštu",
      "Rumunija je članica EU — jednostavno poslovanje u EU",
    ],
    ctaPrimary: "Zatražite ponudu na srpskom",
    ctaSecondary: "Pogledajte usluge",
    imageAlt: "Stvarna kancelarija UBA COMPANY u Bukureštu",
  },
  hungary: {
    lang: "hu",
    docTitle: "UBA COMPANY — Székhely Bukarestben magyar cégeknek",
    badge: "Magyar cégeknek",
    title: "Bejegyzett székhely Bukarestben",
    titleAccent: "az Ön magyar cégének",
    subtitle:
      "Valódi, fizikai iroda Bukarestben — nem virtuális. Teljes körű kiszolgálás magyar nyelven, 24 órán belüli válasszal.",
    heroPrice: "250 RON/év-től · ≈ 50 EUR",
    points: [
      "Minden dokumentum és kommunikáció magyar nyelven",
      "Érvényes székhely az ONRC és minden román hatóság előtt",
      "Átvesszük és továbbítjuk hivatalos levelezését",
      "Románia EU-tagállam — egyszerű uniós üzletmenet",
    ],
    ctaPrimary: "Kérjen ajánlatot magyarul",
    ctaSecondary: "Szolgáltatások",
    imageAlt: "A UBA COMPANY valódi irodája Bukarestben",
  },
  romania: {
    lang: "ro",
    docTitle: "UBA COMPANY — Sediu social și găzduire firmă în București",
    badge: "Pentru firme din România",
    title: "Sediu social și găzduire firmă",
    titleAccent: "în București, pentru firme românești",
    subtitle:
      "Birou fizic real în București — nu virtual. Găzduire firmă cu preț fix, totul inclus. Răspundem în cel mult 24 de ore.",
    heroPrice: "de la 250 RON/an · ≈ 50 EUR",
    points: [
      "Sediu social valabil pentru ONRC și toate instituțiile",
      "Birouri reale pe care le poți folosi cu rezervare",
      "Primim și îți transmitem corespondența oficială",
      "Preț fix, totul inclus — fără costuri ascunse",
    ],
    ctaPrimary: "Solicită oferta",
    ctaSecondary: "Vezi serviciile",
    imageAlt: "Biroul real UBA COMPANY în București",
  },
};
